class EventListener {
  constructor() {
    // Internal mapping for A, W, S keys
    this.mappings = {
      A: null,
      W: null,
      S: null,
    };

    this.A_up = null;
    this.A_down = null;
    this.A_isDown = false;

    // Set up event listeners once
    document.addEventListener("keydown", (event) => {
      const key = event.key.toUpperCase();
      if (this.mappings.hasOwnProperty(key) && this.mappings[key]) {
        this.mappings[key]();
      }
      if (key === "A" && this.A_down && !this.A_isDown) {
        this.A_isDown = true;
        this.A_down();
      }
    });

    document.addEventListener("keyup", (event) => {
      const key = event.key.toUpperCase();
      if (key === "A") {
        this.A_isDown = false;
        if (this.A_up) {
          this.A_up();
        }
      }
    });
  }

  clearMethods() {
    this.mappings.A = null;
    this.mappings.D = null;
    this.mappings.S = null;
    this.A_up = null;
    this.A_down = null;
    this.A_isDown = false;
  }

  setA(func) {
    this.mappings.A = func;
  }

  setD(func) {
    this.mappings.D = func;
  }

  setS(func) {
    this.mappings.S = func;
  }

  setA_up(func) {
    this.A_up = func;
  }

  setA_down(func) {
    this.A_down = func;
  }
}

export const eventListener = new EventListener();
